module.exports = __webpack_public_path__ + "19a661c7b55a254aad58c06eaba6fcae.png";